import { object, string, InferType, array } from 'yup';
import { deepPartialOrNullable } from '../../../../helpers';
import { baseAiGeneratedResponseSchema } from './baseAiGeneratedResponseSchema';
import { AiCareDocumentOvercomeChallengeSchema } from './AiCareDocumentOvercomeChallengeSchema';
import { AiCareDocumentTreatmentDetailsSchema } from './AiCareDocumentTreatmentDetailsSchema';
import { AiCareDocumentWorkDetailsSchema } from './AiCareDocumentWorkDetailsSchema';
import { AiDateSchema } from './AiDateSchema';

export const InitialAssessmentSummaryAiGeneratedSchema = object().shape({
  patient: object()
    .shape({
      cancerType: string().nullable().notRequired(),
      dob: AiDateSchema,
      dateOfDiagnosis: AiDateSchema,
      work: deepPartialOrNullable(AiCareDocumentWorkDetailsSchema)
        .nullable()
        .notRequired(),
    })
    .nullable()
    .notRequired(),
  perciStartDate: AiDateSchema,
  dateOfConsultation: AiDateSchema,

  treatmentDetails: deepPartialOrNullable(AiCareDocumentTreatmentDetailsSchema)
    .nullable()
    .notRequired(),

  planToOvercomeChallenges: array()
    .of(deepPartialOrNullable(AiCareDocumentOvercomeChallengeSchema))
    .nullable()
    .notRequired(),

  expertSummary: string().nullable().notRequired(),
});

export type InitialAssessmentSummaryAiGenerated = InferType<
  typeof InitialAssessmentSummaryAiGeneratedSchema
>;

export const InitialAssessmentSummaryAiGeneratedResponseSchema =
  baseAiGeneratedResponseSchema(InitialAssessmentSummaryAiGeneratedSchema);

export type InitialAssessmentSummaryAiGeneratedResponse = InferType<
  typeof InitialAssessmentSummaryAiGeneratedResponseSchema
>;
